export let ServiceSource = /*#__PURE__*/function (ServiceSource) {
  ServiceSource["Draft"] = "draft";
  ServiceSource["Amendment"] = "amendment";
  return ServiceSource;
}({});

/**
 * Adds support for optional services - when sending a proposal services can be optional,
 * and the client can choose to include/exclude them.
 */

/** This is how the service is saved in the DB. */

export let EffectiveDateSource = /*#__PURE__*/function (EffectiveDateSource) {
  EffectiveDateSource["System"] = "setBySystem";
  EffectiveDateSource["User"] = "setByUser";
  return EffectiveDateSource;
}({});
export let ServiceStatusType = /*#__PURE__*/function (ServiceStatusType) {
  ServiceStatusType["AwaitingApproval"] = "awaitingApproval";
  ServiceStatusType["Approved"] = "approved";
  ServiceStatusType["Amended"] = "amended";
  ServiceStatusType["Completed"] = "completed";
  ServiceStatusType["Terminated"] = "terminated";
  ServiceStatusType["Canceled"] = "canceled";
  return ServiceStatusType;
}({});
export let ServiceChangeItemType = /*#__PURE__*/function (ServiceChangeItemType) {
  ServiceChangeItemType["Pricing"] = "pricing";
  ServiceChangeItemType["Discount"] = "discount";
  ServiceChangeItemType["BillingTrigger"] = "billingTrigger";
  ServiceChangeItemType["Description"] = "description";
  ServiceChangeItemType["PriceIncrease"] = "priceIncrease";
  ServiceChangeItemType["IncludedServicesDescription"] = "includedServicesDescription";
  return ServiceChangeItemType;
}({});

/** Any change in price, pricingType, unitCap, unitName */